var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fast-delivery_3690392 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.5221 70.5078H8.78906C7.16973 70.5078 5.85938 71.8182 5.85938 73.4375C5.85938 75.0568 7.16973 76.3672 8.78906 76.3672H30.5221C32.1414 76.3672 33.4518 75.0568 33.4518 73.4375C33.4518 71.8182 32.1414 70.5078 30.5221 70.5078ZM29.4922 55.8594C29.4922 54.24 28.1818 52.9297 26.5625 52.9297H2.92969C1.31035 52.9297 0 54.24 0 55.8594C0 57.4787 1.31035 58.7891 2.92969 58.7891H26.5625C28.1818 58.7891 29.4922 57.4787 29.4922 55.8594ZM30.5221 35.3516H8.78906C7.16973 35.3516 5.85938 36.6619 5.85938 38.2812C5.85938 39.9006 7.16973 41.2109 8.78906 41.2109H30.5221C32.1414 41.2109 33.4518 39.9006 33.4518 38.2812C33.4518 36.6619 32.1414 35.3516 30.5221 35.3516ZM70.5078 23.7812C70.117 23.7459 69.725 22.7498 69.3313 21.5844L70.5078 17.7734H73.4375C75.0568 17.7734 76.3672 16.4631 76.3672 14.8438C76.3672 13.2244 75.0568 11.9141 73.4375 11.9141H61.7188C60.0994 11.9141 58.7891 13.2244 58.7891 14.8438C58.7891 16.4631 60.0994 17.7734 61.7188 17.7734H64.6484L65.9152 21.3133C65.491 22.5922 65.0691 23.743 64.6484 23.7812C48.2504 25.2686 35.3516 39.0787 35.3516 55.8594C35.3516 73.6291 49.8111 88.0859 67.5781 88.0859C85.3451 88.0859 100 73.6291 100 55.8594C100 39.0787 86.9059 25.2686 70.5078 23.7812Z",
    fill: "url(#paint0_linear_1588_12800)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M85.1562 52.9297H70.5078V38.2812C70.5078 36.6619 69.1975 35.3516 67.5781 35.3516C56.2713 35.3516 47.0703 44.5525 47.0703 55.8594C47.0703 67.1662 56.2713 76.3672 67.5781 76.3672C78.885 76.3672 88.0859 67.1662 88.0859 55.8594C88.0859 54.24 86.7756 52.9297 85.1562 52.9297ZM70.5078 23.7813V17.7734H64.6484V23.7813C65.6148 23.6936 66.5893 23.6328 67.5781 23.6328C68.567 23.6328 69.5414 23.6936 70.5078 23.7813Z",
    fill: "url(#paint1_linear_1588_12800)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1588_12800",
    x1: 50,
    y1: 88.0859,
    x2: 50,
    y2: 11.9141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A93AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF81FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1588_12800",
    x1: 67.5781,
    y1: 76.3672,
    x2: 67.5781,
    y2: 17.7734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF1FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.ec2cbb1eb1a405c19065e58106802ef2.svg";
export { ForwardRef as ReactComponent };